import { Quote, X } from 'lucide-react';
import { cn } from '@/lib/utils';

const QUOTED_PROMPT_PATTERN = /^Regarding this excerpt:\s*\n+"+\s*\n?([\s\S]*?)\n+"+\s*(?:\n+([\s\S]*))?$/;

export function quotedPartsFromMessage(
  content: string,
  metadata: Record<string, unknown>,
): { excerpt: string; question: string } | null {
  const excerptFromMeta = typeof metadata.quoted_excerpt === 'string'
    ? metadata.quoted_excerpt.trim()
    : '';
  if (excerptFromMeta) {
    const questionFromMeta = typeof metadata.quoted_question === 'string'
      ? metadata.quoted_question.trim()
      : '';
    return { excerpt: excerptFromMeta, question: questionFromMeta };
  }

  const match = content.trim().match(QUOTED_PROMPT_PATTERN);
  if (!match) return null;
  return {
    excerpt: match[1].trim(),
    question: (match[2] || '').trim(),
  };
}

interface QuotedExcerptProps {
  text: string;
  onClear?: () => void;
  compact?: boolean;
}

export function QuotedExcerpt({ text, onClear, compact = false }: QuotedExcerptProps) {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-2',
        compact ? '' : 'mx-3 mt-3',
      )}
    >
      <Quote className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-400" />
      <p className="min-w-0 flex-1 line-clamp-3 whitespace-pre-wrap text-xs leading-5 text-slate-600">
        {text}
      </p>
      {onClear && (
        <button
          type="button"
          aria-label="Remove quote"
          className="shrink-0 rounded-md p-0.5 text-slate-400 hover:bg-slate-200/80 hover:text-slate-600"
          onClick={onClear}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
